import { Paragraph4 } from '@nexus/lib-react/dist/core/Typography/Paragraph';
import styled from '../../../../../theme/styled';

import Support from '../images/support.svg';

const Container = styled.div`
  padding: 32px 0;
`;

const Wrapper = styled.div`
  display: flex;
`;

const SupportIcon = styled(Support)`
  margin-right: 20px;
`;

const InfoBlock = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

const Info = styled(Paragraph4)``;

const EmailTo = styled.a`
  margin-top: 16px;
  font-size: ${({ theme }) => theme.sizes.m};
  color: ${({ theme }) => theme.colors.bluePrimary};
  font-weight: ${({ theme }) => theme.fontWeights.medium};
`;

export default { Container, Wrapper, InfoBlock, Info, SupportIcon, EmailTo };
